import { useAuthCopy } from "@/features/i18n/authCopy";
import { cn } from "@/lib/utils";
import { Tabs, TabsList, TabsTrigger } from "@patient-watch/ui/tabs";

interface AuthContactTabsProps {
    value: "email" | "phone";
    onChange: (value: "email" | "phone") => void;
    className?: string;
}

/** Email / phone segmented control for auth forms (tab semantics, keyboard navigable). */
export function AuthContactTabs({ value, onChange, className }: AuthContactTabsProps) {
    const copy = useAuthCopy();

    return (
        <Tabs
            value={value}
            onValueChange={(next) => onChange(next as "email" | "phone")}
            className={cn("w-full", className)}
        >
            <TabsList className="grid grid-cols-2 w-full" aria-label={copy.contactMethodLabel}>
                <TabsTrigger value="email" className="w-full">
                    {copy.emailTab}
                </TabsTrigger>
                <TabsTrigger value="phone" className="w-full">
                    {copy.phoneTab}
                </TabsTrigger>
            </TabsList>
        </Tabs>
    );
}
